var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.20361 12.4273L7.62606 14.4022L17.331 8.80037L13.9069 6.82391L4.20361 12.4273Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6261 14.4022L8.46973 17.8134L18.1746 12.21L17.331 8.80035L7.6261 14.4022Z",
    fill: "#DCDDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20361 12.4273L3.35999 14.8623L8.46968 17.8134L7.62606 14.4022L4.20361 12.4273Z",
    fill: "#C9CACA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.109 15.837L13.5331 17.8134L23.2364 12.21L19.8139 10.2336L10.109 15.837Z",
    fill: "#E6E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5331 17.8134L14.5636 20.9387L24.08 15.6197L23.2364 12.21L13.5331 17.8134Z",
    fill: "#DCDDDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.109 15.837L9.26538 18.272L14.5636 20.9387L13.533 17.8134L10.109 15.837Z",
    fill: "#C9CACA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26184 11.2034L10.6859 13.1798L20.3892 7.57643L16.9668 5.59998L7.26184 11.2034Z",
    fill: "#EFEFEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6858 13.1799L11.5294 16.5895L21.2327 10.9861L20.3891 7.57648L10.6858 13.1799Z",
    fill: "#DCDDDD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26184 11.2034L6.41821 13.6384L11.5295 16.5895L10.6859 13.1799L7.26184 11.2034Z",
    fill: "#C9CACA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4322 16.4322C18.1817 14.6826 21.0183 14.6826 22.7678 16.4322C24.5174 18.1817 24.5174 21.0183 22.7678 22.7678C21.0183 24.5174 18.1817 24.5174 16.4322 22.7678C14.6826 21.0183 14.6826 18.1817 16.4322 16.4322Z",
    fill: "#009245"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7296 21.5108L17.7716 20.5594L16.8202 21.5108L16.4 21.0971L17.358 20.1392L16.4 19.1812L16.8202 18.761L17.7716 19.719L18.7296 18.761L19.1498 19.1812L18.1918 20.1392L19.1498 21.0971L18.7296 21.5108Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9368 21.9636V21.366L21.7351 19.1812C21.8222 19.0724 21.8864 18.97 21.9256 18.8764C21.9648 18.7828 21.9844 18.6761 21.9844 18.5586C21.9844 18.3485 21.9256 18.1776 21.8069 18.0469C21.6883 17.9152 21.5206 17.8499 21.3018 17.8499C21.2147 17.8499 21.1287 17.863 21.046 17.8891C20.9633 17.9152 20.8893 17.9566 20.8261 18.0143C20.763 18.0709 20.7118 18.146 20.6715 18.2374C20.6324 18.3289 20.6128 18.441 20.6128 18.5716H19.9433C19.9433 18.3746 19.977 18.1939 20.0445 18.0306C20.112 17.8662 20.2067 17.728 20.3265 17.6137C20.4462 17.5005 20.5899 17.4112 20.7565 17.3481C20.923 17.2849 21.1037 17.2534 21.3007 17.2534C21.4978 17.2534 21.6861 17.2838 21.8516 17.3448C22.0181 17.4058 22.1596 17.4939 22.2783 17.6071C22.3969 17.7214 22.4884 17.8586 22.5537 18.0208C22.619 18.183 22.6517 18.3648 22.6517 18.5651C22.6517 18.7654 22.6147 18.9472 22.5406 19.0931C22.4666 19.24 22.3567 19.4 22.213 19.5753L20.7499 21.3671H22.6528V21.9647H19.9357L19.9368 21.9636Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgq);
export default __webpack_public_path__ + "static/media/AGQ.fd2d8efb3f270862ce9117d78640679c.svg";
export { ForwardRef as ReactComponent };